import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import {
	Button,
	Input,
	Icon,
	Label,
	Dropdown,
	Dimmer,
	Loader,
	Modal,
	Message,
} from "semantic-ui-react";
import {
	fetchTemplates,
	olayWorkingApi,
	olayInputTemplateApi,
	olayStartProcessApi,
	getOlayFileApi,
} from "../../../actions/users_action";
import { toast } from "react-semantic-toasts";
import config from "../../../config";


class Olay extends React.Component {
	constructor(props) {
		super(props);
		this.statusPollingTimer = null;
		this.pollingStartDelayTimer = null;
		this.state = {
			templates: [],
			templateId: "",
			selectedTemplate: "",
			workingFile: null,
			inputTemplateFile: null,
			uploadedWorkingFile: null,
			uploadedInputTemplateFile: null,
			outputFileKey: "",
			outputGeneratedAt: "",
			processStatus: "",
			workingModalOpen: false,
			inputTemplateModalOpen: false,
			inputTemplateError: "",
			loading: false,
		};
	}

	componentWillUnmount() {
		this.stopStatusPolling();
		this.clearPollingStartDelay();
	}

	getNormalizedStatus = (status) => (status || "").toString().trim().toLowerCase();

	startStatusPolling = () => {
		if (this.statusPollingTimer) {
			return;
		}

		this.statusPollingTimer = setInterval(() => {
			if (this.state.templateId) {
				this.fetchOlayUploadedFiles(this.state.templateId);
			}
		}, 15000);
	};

	stopStatusPolling = () => {
		if (this.statusPollingTimer) {
			clearInterval(this.statusPollingTimer);
			this.statusPollingTimer = null;
		}
	};

	clearPollingStartDelay = () => {
		if (this.pollingStartDelayTimer) {
			clearTimeout(this.pollingStartDelayTimer);
			this.pollingStartDelayTimer = null;
		}
	};

	async componentDidMount() {
		await this.props.fetchTemplates({
			onSuccess: (res) => {
				const templates = res && res.templates ? res.templates : [];
				if (templates.length > 0) {
					const latestTemplate = templates[templates.length - 1];
					this.setState({
						templates,
						selectedTemplate: latestTemplate.name,
						templateId: latestTemplate._id,
					}, () => this.fetchOlayUploadedFiles(latestTemplate._id));
				} else {
					this.setState({ templates: [] });
				}
			},
			onFailure: () => {
				this.setState({ templates: [] });
			},
		});
	}

	dropDownTemplateOnChange = (e, data) => {
		const selected = this.state.templates.find((t) => t.name === data.value);
		const selectedTemplateId = selected ? selected._id : "";
		this.setState({
			selectedTemplate: data.value,
			templateId: selectedTemplateId,
		}, () => this.fetchOlayUploadedFiles(selectedTemplateId));
	};

	fetchOlayUploadedFiles = (templateId) => {
		if (!templateId) {
			this.stopStatusPolling();
			this.clearPollingStartDelay();
			this.setState({
				uploadedWorkingFile: null,
				uploadedInputTemplateFile: null,
				outputFileKey: "",
				outputGeneratedAt: "",
				processStatus: "",
			});
			return;
		}

		this.setState({ loading: true });
		this.props.getOlayFileApi(templateId, {
			onSuccess: (res) => {
				const records = res && res.data ? res.data : [];
				const selectedTemplate = this.state.templates.find((t) => t._id === templateId);
				const selectedTemplateName = selectedTemplate ? selectedTemplate.name : "";
				const matchedRecord = records.find((item) => {
					const recordTemplateId = item && item.template_id && item.template_id.$oid ? item.template_id.$oid : "";
					const recordTemplateName = item && item.template_name ? item.template_name : "";
					return recordTemplateId === templateId || (selectedTemplateName && recordTemplateName === selectedTemplateName);
				}) || null;

				const uploadedWorkingFile = matchedRecord && matchedRecord.base_filename
					? {
						filename: matchedRecord.base_filename,
						fileUrl: matchedRecord.file_url || "",
					}
					: null;

				const inputTemplateData = matchedRecord && matchedRecord.Input_template ? matchedRecord.Input_template : null;
				const uploadedInputTemplateFile = inputTemplateData && inputTemplateData.filename
					? {
						filename: inputTemplateData.filename,
						fileUrl: inputTemplateData.file_url || "",
					}
					: null;

				const processStatus = matchedRecord && matchedRecord.process_status ? matchedRecord.process_status : "";
				const normalizedStatus = this.getNormalizedStatus(processStatus);

				this.setState({
					uploadedWorkingFile,
					uploadedInputTemplateFile,
					outputFileKey: matchedRecord && matchedRecord.output_file_s3_key ? matchedRecord.output_file_s3_key : "",
					outputGeneratedAt:
						matchedRecord && matchedRecord.output_generated_at && matchedRecord.output_generated_at.$date
							? matchedRecord.output_generated_at.$date
							: "",
					processStatus,
					loading: false,
				});

				if (normalizedStatus === "processing") {
					this.startStatusPolling();
				} else {
					this.stopStatusPolling();
				}
			},
			onFailure: () => {
				this.stopStatusPolling();
				this.clearPollingStartDelay();
				this.setState({
					uploadedWorkingFile: null,
					uploadedInputTemplateFile: null,
					outputFileKey: "",
					outputGeneratedAt: "",
					processStatus: "",
					loading: false,
				});
			},
		});
	};

	getDownloadUrl = (fileUrl) => {
		if (!fileUrl) {
			return "";
		}

		if (/^https?:\/\//i.test(fileUrl)) {
			return fileUrl;
		}

		const baseUrl = (config && config.storage_base_url) || "";
		const normalizedBase = baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`;
		const normalizedPath = fileUrl.startsWith("/") ? fileUrl.substring(1) : fileUrl;
		return `${normalizedBase}${normalizedPath}`;
	};

	downloadFile = (fileUrl) => {
		const downloadUrl = this.getDownloadUrl(fileUrl);
		if (!downloadUrl) {
			return;
		}
		window.open(downloadUrl, "_blank");
	};

	onWorkingFileChange = (e) => {
		this.setState({ workingFile: e.target.files[0] });
	};

	onInputTemplateFileChange = (e) => {
		this.setState({ inputTemplateFile: e.target.files[0], inputTemplateError: "" });
	};

	openWorkingModal = () => {
		this.setState({ workingModalOpen: true });
	};

	closeWorkingModal = () => {
		this.setState({ workingModalOpen: false, workingFile: null });
	};

	openInputTemplateModal = () => {
		this.setState({ inputTemplateModalOpen: true, inputTemplateError: "" });
	};

	closeInputTemplateModal = () => {
		this.setState({
			inputTemplateModalOpen: false,
			inputTemplateFile: null,
			inputTemplateError: "",
		});
	};

	getErrorMessage = (err, fallback) => {
		if (!err) return fallback;
		if (typeof err === "string") return err;
		return (
			(err.response && err.response.data && err.response.data.message) || // axios error
			(err.data && err.data.message) ||                                    // wrapped response
			err.message ||                                                       // plain body {message, status:false} or Error
			fallback
		);
	};

	showToast = (type, title, time = 2500) => {
		toast({
			type,
			title,
			description: "",
			time,
		});
	};

	callOlayWorkingApi = (method) => {
		if (!this.state.templateId) {
			this.showToast("warning", "Please select template month");
			return;
		}

		if ((method === "POST" || method === "PUT") && !this.state.workingFile) {
			this.showToast("warning", "Please select Olay Working file");
			return;
		}

		const formData = new FormData();
		formData.append("template_id", this.state.templateId);
		if (this.state.workingFile) {
			formData.append("file", this.state.workingFile);
			formData.append("fileName", this.state.workingFile.name);
		}

		this.setState({ loading: true });
		this.props.olayWorkingApi(formData, method, {
			onSuccess: () => {
				this.setState({ loading: false }, () => this.fetchOlayUploadedFiles(this.state.templateId));
				this.showToast("success", `Olay Working ${method} success`);
			},
			onFailure: () => {
				this.setState({ loading: false });
				this.showToast("error", `Olay Working ${method} failed`);
			},
		});
	};

	callOlayInputTemplateApi = (method) => {
		if (!this.state.templateId) {
			this.showToast("warning", "Please select template month");
			return;
		}

		if ((method === "POST" || method === "PUT") && !this.state.inputTemplateFile) {
			this.showToast("warning", "Please select Olay Input Template file");
			return;
		}

		const formData = new FormData();
		formData.append("template_id", this.state.templateId);
		if (this.state.inputTemplateFile) {
			formData.append("file", this.state.inputTemplateFile);
			formData.append("fileName", this.state.inputTemplateFile.name);
		}

		this.setState({ loading: true, inputTemplateError: "" });
		this.props.olayInputTemplateApi(formData, method, {
			onSuccess: (res) => {
				// API may return HTTP 200 with { status: false, message: "..." }
				if (res && res.status === false) {
					const msg = this.getErrorMessage(res, `Olay Input Template ${method} failed`);
					this.setState({ loading: false, inputTemplateError: msg });
					this.showToast("error", msg, 6000);
					return;
				}

				this.setState({ loading: false }, () => this.fetchOlayUploadedFiles(this.state.templateId));
				this.showToast("success", `Olay Input Template ${method} success`);
			},
			onFailure: (error) => {
				const msg = this.getErrorMessage(error, `Olay Input Template ${method} failed`);
				this.setState({ loading: false, inputTemplateError: msg });
				this.showToast("error", msg, 6000);
			},
		});
	};

	startOlayProcess = (isRerun = false) => {
		if (!this.state.templateId) {
			this.showToast("warning", "Please select template month");
			return;
		}

		const payload = { template_id: this.state.templateId };
		if (isRerun) payload.runtype = "rerun";

		this.setState({ loading: true });
		this.props.olayStartProcessApi(payload, {
			onSuccess: () => {
				this.stopStatusPolling();
				this.clearPollingStartDelay();

				this.setState({ loading: false, processStatus: "processing" });
				this.pollingStartDelayTimer = setTimeout(() => {
					this.pollingStartDelayTimer = null;
					this.fetchOlayUploadedFiles(this.state.templateId);
				}, 180000);
				this.showToast("success", "Olay process started successfully");
			},
			onFailure: () => {
				this.setState({ loading: false });
				this.showToast("error", "Failed to start Olay process");
			},
		});
	};

	render() {
		const templateMonths = this.state.templates.map((d) => ({
			key: d._id,
			value: d.name,
			text: d.name,
		}));
		const normalizedProcessStatus = this.getNormalizedStatus(this.state.processStatus);
		const isProcessing = normalizedProcessStatus === "processing";
		const canStartProcess =
			!!this.state.uploadedWorkingFile &&
			!!this.state.uploadedWorkingFile.fileUrl &&
			!!this.state.uploadedInputTemplateFile &&
			!!this.state.uploadedInputTemplateFile.fileUrl;
		const isCompleted = normalizedProcessStatus === "completed";
		const hasUploadedWorkingFile = !!this.state.uploadedWorkingFile && !!this.state.uploadedWorkingFile.filename;
		const hasUploadedInputTemplateFile = !!this.state.uploadedInputTemplateFile && !!this.state.uploadedInputTemplateFile.filename;
		const hasOutputFile = !!this.state.outputFileKey;
		const isAnyModalOpen = this.state.workingModalOpen || this.state.inputTemplateModalOpen;
		const modalActionLoading = this.state.loading && isAnyModalOpen;
		const processStatusColor =
			normalizedProcessStatus === "completed"
				? "#21ba45"
				: normalizedProcessStatus === "processing"
					? "#f2c037"
					: "#767676";
		const outputFileName = hasOutputFile ? this.state.outputFileKey.split("/").pop().split("?")[0] : "";

		return (
			<div>
				<Dimmer active={this.state.loading && !isAnyModalOpen}>
					<Loader size="large">Processing...</Loader>
				</Dimmer>

				<div style={{ display: "flex", alignItems: "center", marginBottom: 20 }}>
					<Label size="large" color="blue" style={{ marginRight: 10 }}>
						Template Month
					</Label>
					<Dropdown
						placeholder="Select Template Month"
						search
						selection
						options={templateMonths}
						onChange={this.dropDownTemplateOnChange}
						value={this.state.selectedTemplate}
					/>
					<Button
						basic
						color="blue"
						icon
						labelPosition="left"
						style={{ marginLeft: 20 }}
						onClick={this.openWorkingModal}
					>
						<Icon name="upload" />
						Upload Base File
					</Button>
					<Button
						basic
						color="purple"
						icon
						labelPosition="left"
						style={{ marginLeft: 10 }}
						onClick={this.openInputTemplateModal}
					>
						<Icon name="file alternate" />
						Template Input
					</Button>
					{canStartProcess && (
						<Label
							style={{ marginLeft: 20, cursor: "pointer" }}
							size="large"
							basic
							color={isProcessing ? "yellow" : "green"}
							onClick={() => !isProcessing && this.startOlayProcess(isCompleted)}
						>
							{isProcessing ? "Processing" : isCompleted ? "Rerun" : "Start Process"}
						</Label>
					)}
				</div>

				<div
					style={{
						marginBottom: 20,
						padding: isCompleted ? "16px 20px" : "14px 18px",
						borderRadius: 12,
						border: isCompleted ? "1px solid #b8eec9" : "1px solid #dfe3e8",
						background: isCompleted ? "linear-gradient(135deg, #f0fff5 0%, #e5f9ef 100%)" : "#f9fbfd",
						boxShadow: isCompleted ? "0 8px 22px rgba(33, 186, 69, 0.12)" : "none",
						display: "inline-flex",
						justifyContent: "space-between",
						alignItems: "center",
						minWidth: 380,
						gap: 24,
					}}
				>
					{hasOutputFile ? (
						<>
							<div>
								<div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
									{isCompleted && <Icon name="check circle" style={{ color: "#1f9d48", fontSize: 18, margin: 0 }} />}
									<div style={{ fontSize: 14, fontWeight: 700, color: "#1d2939" }}>Output File</div>
								</div>
								<div style={{ marginBottom: 6, fontSize: 13 }}>
									<strong>Status:</strong>{" "}
									<span style={{ color: processStatusColor, fontWeight: 600 }}>
										{this.state.processStatus || "Not Started"}
									</span>
								</div>
								<div style={{ marginBottom: 6, fontSize: 13, color: "#344054" }}>
									<strong>File:</strong> {outputFileName}
								</div>
								{this.state.outputGeneratedAt && (
									<div style={{ fontSize: 13, color: "#344054" }}>
										<strong>Generated At:</strong> {new Date(this.state.outputGeneratedAt).toLocaleString()}
									</div>
								)}
							</div>
							<Button
								color={isCompleted ? "green" : "teal"}
								icon
								onClick={() => this.downloadFile(this.state.outputFileKey)}
								title="Download Output"
								aria-label="Download Output"
							>
								<Icon name="download" />
							</Button>
						</>
					) : isProcessing ? (
						<div style={{ display: "flex", alignItems: "center", gap: 12 }}>
							<Icon name="spinner" loading style={{ color: "#f2c037", fontSize: 22, margin: 0 }} />
							<div>
								<div style={{ fontSize: 13, fontWeight: 600, color: "#344054", marginBottom: 2 }}>
									Processing
								</div>
								<div style={{ fontSize: 12, color: "#98a2b3" }}>
									Your output is being generated.
								</div>
							</div>
						</div>
					) : (
						<div style={{ display: "flex", alignItems: "center", gap: 12 }}>
							<Icon name="info circle" style={{ color: "#a0aec0", fontSize: 22, margin: 0 }} />
							<div>
								<div style={{ fontSize: 13, fontWeight: 600, color: "#344054", marginBottom: 2 }}>
									Process Not Started
								</div>
								<div style={{ fontSize: 12, color: "#98a2b3" }}>
									Upload the Base File &amp; Template Input to begin.
								</div>
							</div>
						</div>
					)}
				</div>

				{/* ---------------- Upload Base File modal ---------------- */}
				<Modal open={this.state.workingModalOpen} onClose={this.closeWorkingModal} size="small">
					<Modal.Header>Upload Base File</Modal.Header>
					<Modal.Content>
						<div
							style={{
								border: "2px dashed #d0d5dd",
								borderRadius: 12,
								padding: "28px 20px",
								textAlign: "center",
								background: "#f8fafc",
								marginTop: 8,
								cursor: "pointer",
								transition: "border-color 0.2s",
							}}
							onMouseEnter={(e) => (e.currentTarget.style.borderColor = "#2185d0")}
							onMouseLeave={(e) => (e.currentTarget.style.borderColor = "#d0d5dd")}
							onClick={() => document.getElementById("workingFileInput").click()}
						>
							<Icon name="cloud upload" size="large" style={{ color: "#2185d0", marginBottom: 8 }} />
							<div style={{ fontSize: 15, fontWeight: 600, color: "#344054", marginBottom: 4 }}>
								{this.state.workingFile ? this.state.workingFile.name : "Click to choose a file"}
							</div>
							<div style={{ fontSize: 12, color: "#98a2b3" }}>Accepts .xlsx files only</div>
							<input
								id="workingFileInput"
								type="file"
								accept=".xlsx"
								style={{ display: "none" }}
								onChange={this.onWorkingFileChange}
							/>
						</div>

						<div
							style={{
								marginTop: 16,
								padding: "10px 14px",
								borderRadius: 8,
								background: "#f0f4ff",
								border: "1px solid #c7d7fd",
								display: "flex",
								alignItems: "center",
								gap: 8,
							}}
						>
							<Icon name="file excel outline" style={{ color: "#2185d0", margin: 0 }} />
							<div style={{ fontSize: 13, color: "#344054" }}>
								<strong>Uploaded:</strong>{" "}
								<span style={{ color: this.state.uploadedWorkingFile ? "#16a34a" : "#98a2b3" }}>
									{this.state.uploadedWorkingFile ? this.state.uploadedWorkingFile.filename : "No file uploaded yet"}
								</span>
							</div>
						</div>
					</Modal.Content>

					<Modal.Actions>
						{!hasUploadedWorkingFile && (
							<Button basic color="green" icon labelPosition="left" loading={modalActionLoading} disabled={modalActionLoading} onClick={() => this.callOlayWorkingApi("POST")}>
								<Icon name="upload" />
								Upload
							</Button>
						)}
						{hasUploadedWorkingFile && !isProcessing && (
							<Button basic color="blue" icon labelPosition="left" loading={modalActionLoading} disabled={modalActionLoading} onClick={() => this.callOlayWorkingApi("PUT")}>
								<Icon name="refresh" />
								Update
							</Button>
						)}
						{hasUploadedWorkingFile && (
							<Button
								basic
								color="teal"
								icon
								labelPosition="left"
								loading={modalActionLoading}
								disabled={modalActionLoading || !this.state.uploadedWorkingFile || !this.state.uploadedWorkingFile.fileUrl}
								onClick={() => this.downloadFile(this.state.uploadedWorkingFile ? this.state.uploadedWorkingFile.fileUrl : "")}
							>
								<Icon name="download" />
								Download
							</Button>
						)}
						{hasUploadedWorkingFile && !isProcessing && (
							<Button basic color="red" icon labelPosition="left" loading={modalActionLoading} disabled={modalActionLoading} onClick={() => this.callOlayWorkingApi("DELETE")}>
								<Icon name="trash" />
								Delete
							</Button>
						)}
						<Button basic disabled={modalActionLoading} onClick={this.closeWorkingModal}>Close</Button>
					</Modal.Actions>
				</Modal>

				{/* ---------------- Template Input modal ---------------- */}
				<Modal open={this.state.inputTemplateModalOpen} onClose={this.closeInputTemplateModal} size="small">
					<Modal.Header>Template Input</Modal.Header>
					<Modal.Content>
						{this.state.inputTemplateError && (
							<Message negative style={{ marginBottom: 16 }}>
								<Icon name="warning circle" />
								{this.state.inputTemplateError}
							</Message>
						)}

						<div
							style={{
								border: "2px dashed #d0d5dd",
								borderRadius: 12,
								padding: "28px 20px",
								textAlign: "center",
								background: "#f8fafc",
								marginTop: 8,
								cursor: "pointer",
								transition: "border-color 0.2s",
							}}
							onMouseEnter={(e) => (e.currentTarget.style.borderColor = "#a855f7")}
							onMouseLeave={(e) => (e.currentTarget.style.borderColor = "#d0d5dd")}
							onClick={() => document.getElementById("inputTemplateFileInput").click()}
						>
							<Icon name="cloud upload" size="large" style={{ color: "#a855f7", marginBottom: 8 }} />
							<div style={{ fontSize: 15, fontWeight: 600, color: "#344054", marginBottom: 4 }}>
								{this.state.inputTemplateFile ? this.state.inputTemplateFile.name : "Click to choose a file"}
							</div>
							<div style={{ fontSize: 12, color: "#98a2b3" }}>Accepts .xlsx files only</div>
							<input
								id="inputTemplateFileInput"
								type="file"
								accept=".xlsx"
								style={{ display: "none" }}
								onChange={this.onInputTemplateFileChange}
							/>
						</div>

						<div
							style={{
								marginTop: 16,
								padding: "10px 14px",
								borderRadius: 8,
								background: "#faf0ff",
								border: "1px solid #e9d5ff",
								display: "flex",
								alignItems: "center",
								gap: 8,
							}}
						>
							<Icon name="file alternate outline" style={{ color: "#a855f7", margin: 0 }} />
							<div style={{ fontSize: 13, color: "#344054" }}>
								<strong>Uploaded:</strong>{" "}
								<span style={{ color: this.state.uploadedInputTemplateFile ? "#16a34a" : "#98a2b3" }}>
									{this.state.uploadedInputTemplateFile ? this.state.uploadedInputTemplateFile.filename : "No file uploaded yet"}
								</span>
							</div>
						</div>
					</Modal.Content>
					<Modal.Actions>
						{!hasUploadedInputTemplateFile && (
							<Button basic color="green" icon labelPosition="left" loading={modalActionLoading} disabled={modalActionLoading} onClick={() => this.callOlayInputTemplateApi("POST")}>
								<Icon name="upload" />
								Upload
							</Button>
						)}
						{hasUploadedInputTemplateFile && !isProcessing && (
							<Button basic color="blue" icon labelPosition="left" loading={modalActionLoading} disabled={modalActionLoading} onClick={() => this.callOlayInputTemplateApi("PUT")}>
								<Icon name="refresh" />
								Update
							</Button>
						)}
						{hasUploadedInputTemplateFile && (
							<Button
								basic
								color="teal"
								icon
								labelPosition="left"
								loading={modalActionLoading}
								disabled={modalActionLoading || !this.state.uploadedInputTemplateFile || !this.state.uploadedInputTemplateFile.fileUrl}
								onClick={() => this.downloadFile(this.state.uploadedInputTemplateFile ? this.state.uploadedInputTemplateFile.fileUrl : "")}
							>
								<Icon name="download" />
								Download
							</Button>
						)}
						{hasUploadedInputTemplateFile && !isProcessing && (
							<Button basic color="red" icon labelPosition="left" loading={modalActionLoading} disabled={modalActionLoading} onClick={() => this.callOlayInputTemplateApi("DELETE")}>
								<Icon name="trash" />
								Delete
							</Button>
						)}
						<Button basic disabled={modalActionLoading} onClick={this.closeInputTemplateModal}>Close</Button>
					</Modal.Actions>
				</Modal>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		auth: state.auth,
		user: state.user,
	};
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			fetchTemplates,
			olayWorkingApi,
			olayInputTemplateApi,
			olayStartProcessApi,
			getOlayFileApi,
		},
		dispatch
	);
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Olay));